// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpRFDUs01kYOCFGEBxz2{color:var(--red-60);align-items:center;gap:4px;font-size:11px;font-weight:400;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorContainer": `SpRFDUs01kYOCFGEBxz2`
};
export default ___CSS_LOADER_EXPORT___;
